import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=0696a80d&lang=less"
import "./index.vue?vue&type=style&index=1&id=0696a80d&lang=less&scoped=true"
script.__scopeId = "data-v-0696a80d"

export default script